import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=719ba627&scoped=true"
import script from "./index copy 2.vue?vue&type=script&lang=js"
export * from "./index copy 2.vue?vue&type=script&lang=js"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=719ba627&prod&lang=less&scoped=true"
import style1 from "./index copy 2.vue?vue&type=style&index=1&id=719ba627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ba627",
  null
  
)

export default component.exports